// extracted by mini-css-extract-plugin
export var cardIcon = "_8m-5";
export var cardIconUnframed = "_8m-9";
export var checkboxCard = "_8m-0";
export var checkboxCardSelected = "_8m-4";
export var disabled = "_8m-2";
export var interactive = "_8m-1";
export var outerBorder = "_8m-3";
export var spacerMedium = "_8m-8";
export var spacerSmall = "_8m-7";
export var spacerXsmall = "_8m-6";